import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=282ead08&scoped=true"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"
import style0 from "./Position.vue?vue&type=style&index=0&id=282ead08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ead08",
  null
  
)

export default component.exports